import { useQuery } from '@tanstack/react-query';
import { fetchGroupPermissionsForAll } from '../../../api/permissions';

export function useGroupPermissionsForAllQuery(groupId: string) {
  return useQuery({
    queryKey: ['group-permissions-for-all', groupId],
    queryFn: () => fetchGroupPermissionsForAll(groupId),
    gcTime: 0,
    staleTime: 0,
  });
}
